import { BuyButton } from "../BuyButton";

export function FinalCta() {
  return (
    <section className="border-t border-[#23211c] bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#8a8578]">
          SayIt Manager Edition
        </p>
        <h2 className="mx-auto mt-6 max-w-2xl font-display text-4xl font-light leading-[1.1] tracking-tight text-paper sm:text-5xl">
          The next difficult conversation is already on your calendar.
        </h2>
        <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-[#a8a499]">
          Walk into it knowing exactly what you're going to say.
        </p>
        <div className="mt-10 flex justify-center">
          <BuyButton
            testid="final-cta-button"
            source="final"
            label="Get all 100 messages"
            className="!bg-paper !text-ink hover:!bg-white"
          />
        </div>
        <p className="mt-5 text-[13px] text-[#6b675c]">
          Instant digital download · One-time payment · No subscription
        </p>
      </div>
    </section>
  );
}
